/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @preferred
 * @module DiagramModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { VIPModule } from '@vmw/ngx-vip';
import { ClrSpinnerModule } from '@clr/angular';
import { SharedModule } from 'ng/shared/shared.module';
import { CoreModule } from '../core/core.module';
import { TooltipModule } from '../tooltip/tooltip.module';

import {
    AviAreaGraphComponent,
    AviBarGraphComponent,
    AviBarGraphTooltipComponent,
    AviLegendComponent,
    DoubleArrowComponent,
    LabelColorOptionalComponent,
    LabelCountLegendComponent,
    LabelCountRowComponent,
} from './components';

const components = [
    AviAreaGraphComponent,
    AviBarGraphComponent,
    AviBarGraphTooltipComponent,
    AviLegendComponent,
    DoubleArrowComponent,
    LabelColorOptionalComponent,
    LabelCountLegendComponent,
    LabelCountRowComponent,
];

@NgModule({
    declarations: [
        ...components,
    ],
    exports: [
        AviBarGraphComponent,
        AviAreaGraphComponent,
        DoubleArrowComponent,
        LabelColorOptionalComponent,
        LabelCountLegendComponent,
        LabelCountRowComponent,
    ],
    imports: [
        ClrSpinnerModule,
        CommonModule,
        CoreModule,
        TooltipModule,
        VIPModule,
        SharedModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DiagramModule {}
